export default "__VITE_ASSET__CnMZOPKM__"